import * as React from 'react';
import * as turf from '@turf/helpers';
import { Map, Source, Layer, ViewStateChangeEvent } from 'react-map-gl';

import { App } from '../../App';
import { MarkersCircleLayer, MarkersStrokeLayer } from '../Layers';
import { MapControls } from '../MapControls/MapControls';

interface IProps {
  // Location initially shown op map. Can be null.
  lat?: number;
  lng?: number;
  // Initial zoom level.
  zoom: number;  
}

const LocationMap = (props: IProps) => {
  // If lng/lat prop a valid location?
  const isLocationValid = (): boolean => {
    if(isNaN(parseFloat(props.lat as any)) || isNaN(parseFloat(props.lng as any))) {
       return false;
    }
    return true;
  }  

  const [viewState, setViewState] = React.useState({
    longitude: isLocationValid() ? props.lng : 0,
    latitude: isLocationValid() ? props.lat : 0,
    zoom: props.zoom ?? 1,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, bottom: 0, left: 0, right: 0 }    
  });  

  const handleMove = (e: ViewStateChangeEvent) => {
    setViewState(e.viewState);
  }

  const getGeoJSON = () => {
    if(isLocationValid()) {
      return turf.featureCollection([turf.point([props.lng, props.lat])])
    } else {
      return turf.featureCollection([]);
    }
  }

  return (
    <Map
      {...viewState}
      mapboxAccessToken={App.config.mapboxKey}
      style={{width: '100%', height: '100%'}}
      logoPosition="bottom-left"  // Moves mapbox logo
      fadeDuration={0}            // Prevents fading in of cluster labels
      interactiveLayerIds={[]}
      mapStyle="mapbox://styles/longlineenvironment/cl8x4af5v003n14ld74f6ugwd"
      minZoom={1}
      maxZoom={20}
      doubleClickZoom={false}
      //Events
      onMove={handleMove}      
    >
      <MapControls {...viewState}/>

      <Source type="geojson" data={getGeoJSON()}>
        <Layer {...MarkersCircleLayer}/>
        <Layer {...MarkersStrokeLayer}/>
      </Source>

    </Map>
  );
}

export { LocationMap }
